import { Component, OnInit, AfterViewInit } from '@angular/core';
import { BasicError } from '../../models/error/error';
import { User } from '../../models/user';
import { Alarm } from '../../models/alarm';
import { Answersheet } from '../../models/answersheet';
import { Questionnaire } from '../../models/questionnaire';
import { AlarmService } from '../../services/alarm.service';
import { HcpQuestionnaireService } from '../../services/hcp-questionnaire.service';
import { TranslateService } from '../../services/translate.service';
import { MessageService } from '../../services/message.service';
import {
  QuestionnaireElement, QuestionnaireElementHeadline, QuestionnaireElementYesNo,
  QuestionnaireElementSlider, QuestionnaireElementSingleChoice, QuestionnaireElementTextDate,
  QuestionnaireElementMultipleChoice, QuestionnaireElementTextString,
  QuestionnaireElementTextArea
} from '../../models/questionnaire-element';
import { Thread } from '../../models/thread';
declare var $: any;

@Component({
  selector: 'app-hcpalarms-list',
  templateUrl: './hcpalarms-list.component.html',
  styleUrls: ['./hcpalarms-list.component.css']
})
export class HCPAlarmsListComponent implements OnInit, AfterViewInit {
  public isEmptyAlarms = false;
  public isLoading = true;
  public alarmUsers = {};
  public users = [];
  public allUsers = {};
  public lastUpdateCount = 0;
  public timeout = null;
  public gotAlarmOnce = false;
  public showAlarmsArr = {};
  public showAlarmAnswersheets = [];
  public showQuestionnaires = [];
  public showQuestionnairesStructure = {};
  public showQuestionnairesMap = {};
  public showUser = null;
  public locale = null;
  public subject = '';
  public message = '';
  public mailUser = null;
  public isErrorMessage = false;
  public isErrorSubject = false;
  public buttonClass: String = '';
  public buttonValue: String = 'Senden';
  public onSend = false;
  public thread = null;
  public successSend = false;

  constructor(private alarm: AlarmService, private questionnaire: HcpQuestionnaireService, private translate: TranslateService,
    private messageService: MessageService) {
    this.locale = this.translate.getSingleElementLanguage();
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    $(document).ready(function () {
      $('[data-toggle="tooltip"]').tooltip();
    });

    this.alarm.observe().subscribe(json => {
      if (!this.gotAlarmOnce) {
        this.gotAlarmOnce = true;
        $('#datatable').dataTable().fnDestroy();
        this.isLoading = false;
        const rr = this.alarm.getCurrentAlarms();
        this.checkAlarms(rr);
      }
    });

    const rr = this.alarm.getCurrentAlarms();
    if (rr.alarms.length > 0 || rr.warnings.length > 0) {
      this.isEmptyAlarms = false;
    }
    this.checkAlarms(rr);
  }

  /**
   * This function analyses the alarms and sorts them into
   * alarmUsers users and allUsers
   * @param rr Alarm set (warnings and alarms)
   */
  public checkAlarms(rr) {
    const alarms = rr.alarms;
    const warnings = rr.warnings;

    this.allUsers = {};
    this.users = [];
    this.alarmUsers = {};
    this.lastUpdateCount = 0;

    // $('#datatable').dataTable().fnDestroy();

    // Getting all alarms and sort it
    for (const a of alarms) {
      if (a instanceof Alarm) {
        if (this.allUsers[a.getUser().getID().toString()] === undefined) {
          // User wasn't found until now, first alarm
          this.allUsers[a.getUser().getID().toString()] = a.getUser();
          this.users.push(a.getUser());
          this.alarmUsers[a.getUser().getID().toString()] = {
            'alarms': [],
            'warnings': []
          };
          this.alarmUsers[a.getUser().getID().toString()].alarms.push(a);
        } else {
          this.alarmUsers[a.getUser().getID().toString()].alarms.push(a);
        }
      }
    }

    // Getting warnings and sort it
    for (const a of warnings) {
      if (a instanceof Alarm) {
        if (this.allUsers[a.getUser().getID().toString()] === undefined) {
          // User wasn't found until now, first alarm
          this.allUsers[a.getUser().getID().toString()] = a.getUser();
          this.users.push(a.getUser());
          this.alarmUsers[a.getUser().getID().toString()] = {
            'alarms': [],
            'warnings': []
          };
          this.alarmUsers[a.getUser().getID().toString()].warnings.push(a);
        } else {
          this.alarmUsers[a.getUser().getID().toString()].warnings.push(a);
        }
      }
    }

    if (this.users.length > 0) {
      this.isEmptyAlarms = false;
    } else {
      this.isEmptyAlarms = true;
    }

  }

  /**
   * Function for datatable, some bug fixes
   */
  public updateRows() {
    if (this.lastUpdateCount !== this.users.length) {
      this.lastUpdateCount = this.users.length;

      if (this.timeout !== null) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(function () {
        $('#datatable').DataTable({
          'destroy': true,
          'pageLength': 25
        });
      }, 200);
    }
  }

  /**
   * converting unix timestamp into a timestamp String
   * @param timestamp timestamp (UNIX timestamp)
   */
  public getFormatedDate(timestamp: Number) {
    const date = new Date();
    date.setTime((timestamp.valueOf() * 1000));

    const weekdays = ['Montag', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag', 'Sonntag'];

    const months = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];

    let dateString = weekdays[date.getDay()] + ' den ' + date.getDate() + '. ';
    dateString += months[date.getMonth()] + ' ' + date.getFullYear();
    dateString += ' [';
    dateString += (date.getHours() < 10) ? '0' + date.getHours() : date.getHours();
    dateString += ':';
    dateString += (date.getMinutes() < 10) ? '0' + date.getMinutes() : date.getMinutes();
    dateString += ' Uhr]';

    return dateString;
  }

  /**
   * Displaying all alarm relevant Data
   * @param user user to get alarm from
   * @param alarmSet alarm set from user
   */
  public showAlarms(user: User, alarmSet) {
    this.showUser = user;
    this.showAlarmsArr = {};
    this.showAlarmAnswersheets = [];
    this.showQuestionnaires = [];
    this.showQuestionnairesMap = {};
    // Look up for the answersheets, that are connected with it
    const answersheetIds = [];
    const answersheetIdsMap = {};

    for (const a of alarmSet.alarms) {
      if (a instanceof Alarm && answersheetIdsMap[a.getAnswersheetId().toString()] === undefined) {
        answersheetIdsMap[a.getAnswersheetId().toString()] = [a];
        answersheetIds.push(a.getAnswersheetId());
      } else {
        answersheetIdsMap[a.getAnswersheetId().toString()].push(a);
      }
    }

    for (const a of alarmSet.warnings) {
      if (a instanceof Alarm && answersheetIdsMap[a.getAnswersheetId().toString()] === undefined) {
        answersheetIdsMap[a.getAnswersheetId().toString()] = [a];
        answersheetIds.push(a.getAnswersheetId());
      } else {
        answersheetIdsMap[a.getAnswersheetId().toString()].push(a);
      }
    }

    // Got answersheetIds for each alarm, now get all answersheets of the list
    for (const id of answersheetIds) {
      const ans = new Answersheet(id);
      const quest = new Questionnaire(answersheetIdsMap[id.toString()][0].getQuestionnaireId());

      if (this.showQuestionnairesMap[quest.getId().toString()] !== undefined) {
        // Get Answersheet in detail
        this.questionnaire.getAnswersheetDetail(
          answersheetIdsMap[ans.getId().toString()][0].getStudyId(), user.getID(), ans).subscribe(json => {
            if (json instanceof BasicError) {
              console.log('Failed to get Answersheet with the id');
              return;
            }

            // Got answersheet, add it to the list
            if (json instanceof Answersheet) {
              this.showAlarmAnswersheets.push(json);
              this.showAlarmsArr[json.getId().toString()] = answersheetIdsMap[json.getId().toString()];
            }
          });
        continue;
      }

      this.questionnaire.getQuestionnaireDetail(quest).subscribe(dd => {
        if (dd instanceof BasicError) {
          console.log('Failed to get Questionnaire');
          return;
        }

        if (this.showQuestionnairesMap[dd.getId().toString()] === undefined) {
          this.showQuestionnaires.push(dd);
          this.showQuestionnairesMap[dd.getId().toString()] = [];

          // Getting Structure of Questionnaire
          this.questionnaire.getQuestionnaireElements(quest).subscribe(json => {
            if (json instanceof BasicError) {
              console.log('failed to get structure of questionnaire');
              console.log(json);
              return;
            }

            this.showQuestionnairesStructure[quest.getId().toString()] = json;

          });
        }

        // Get Answersheet in detail
        this.questionnaire.getAnswersheetDetail(
          answersheetIdsMap[ans.getId().toString()][0].getStudyId(), user.getID(), ans).subscribe(json => {
            if (json instanceof BasicError) {
              console.log('Failed to get Answersheet with the id');
              return;
            }

            // Got answersheet, add it to the list
            if (json instanceof Answersheet) {
              this.showAlarmAnswersheets.push(json);
              this.showAlarmsArr[json.getId().toString()] = answersheetIdsMap[json.getId().toString()];
              this.showQuestionnairesMap[dd.getId().toString()].push(json);
            }
          });

      });
    }
  }

  /**
   * Function to return the answer of an element
   * @param answer answersheet to get answer from
   * @param elem element to define which answer
   */
  public getAnswer(ans: Answersheet, elem: any) {
    const label = elem.getLabel();
    const answers = ans.getAnswers();
    let value = null;

    if (answers instanceof Array) {
      for (let i = 0; i < answers.length; i++) {
        const a: any = answers[i];
        if (a.label === label) {
          // Label was found
          value = a.value;
          break;
        }
      }
    }

    if (value !== null) {
      if (elem instanceof QuestionnaireElementSlider || elem instanceof QuestionnaireElementTextArea ||
        elem instanceof QuestionnaireElementTextDate || elem instanceof QuestionnaireElementTextString) {
        return value;
      } else if (elem instanceof QuestionnaireElementMultipleChoice) {
        const values = elem.getValues();
        const elemAnswers = elem.getAnswers(this.locale);
        let retString = '';

        for (let i = 0; i < values.length; i++) {
          for (let j = 0; j < value.length; j++) {
            if (values[i] === value[j]) {
              (retString === '') ? retString = elemAnswers[i] : retString += ', ' + elemAnswers[i];
            }
          }
        }

        return retString;
      } else {
        let index = null;
        for (let i = 0; i < elem.getValues().length; i++) {
          if (elem.getValues()[i] === value) {
            index = i;
            break;
          }
        }

        if (index !== null) {
          return elem.getAnswers(this.locale)[index];
        } else {
          return 'n/a';
        }
      }
    } else {
      return 'n/a';
    }
  }

  /**
   * This function prepares the send formular.
   * @param user user which should get message
   * @param subject initialize it with this subject
   * @param msg initialize it with this message
   */
  public prepareSend(user: User, subject: String = null, msg: String = null) {
    this.mailUser = user;
    (subject !== null) ? this.subject = subject.toString() : this.subject = '';
    (msg !== null) ? this.message = msg.toString() : this.message = '';

    this.successSend = false;
    this.onSend = false;
    this.buttonValue = 'Senden';
    this.buttonClass = '';

    setTimeout(function () { $('#ModalShowDetails').modal('hide'); }, 100);
    setTimeout(function () { $('#ModalSendMessage').modal('show'); }, 800);
  }

  /**
   * This function prepares the send formular with a summary of all alarm tipps
   * @param user User to get the messages
   * @param alarmSet Alarms that contains the tipps
   * @param ans Answersheet the message was sent of
   */
  public prepareSendSummary(user: User, alarmSet: Array<Alarm>, ans: Answersheet) {
    const subject = 'Feedback zum ausgefüllten Fragebogen vom - ' + this.getFormatedDate(ans.getCollectedAt());

    // Getting message to be send
    let msg = null;

    for (const alarm of alarmSet) {
      if (alarm.isAlarm()) {
        if (msg !== null) {
          msg += '\n\n';
        } else {
          msg = '';
        }

        msg += alarm.getHeadline() + ':\n';
        msg += alarm.getText();
      }
    }

    this.mailUser = user;
    this.subject = subject;
    this.message = msg;

    this.successSend = false;
    this.onSend = false;
    this.buttonValue = 'Senden';
    this.buttonClass = '';

    setTimeout(function () { $('#ModalShowDetails').modal('hide'); }, 100);
    setTimeout(function () { $('#ModalSendMessage').modal('show'); }, 800);
  }

  /**
   * Function to send message to an explicit user
   */
  public sendMessage() {
    let isOk = true;
    this.isErrorSubject = false;
    this.isErrorMessage = false;

    if (this.subject === null || this.subject.length === 0) {
      this.isErrorSubject = true;
      isOk = false;
    }

    if (this.message === null || this.message.length === 0) {
      this.isErrorMessage = true;
      isOk = false;
    }

    if (!isOk) {
      return;
    }

    if (this.mailUser === null) {
      return;
    }

    if (this.onSend) {
      return;
    }

    this.onSend = true;

    this.buttonClass = 'sendingButton';
    this.buttonValue = 'Wird gesendet...';

    // Create thread
    const thread = new Thread(null, this.subject);
    this.messageService.createNewThread(thread).subscribe(res => {
      if (res instanceof BasicError) {
        console.log('Failed to create Thread.');
        console.log(res);
        this.buttonClass = 'btn-danger';
        this.buttonValue = 'Senden fehlgeschlagen';
        this.onSend = false;
        return;
      }

      // Thread was created
      if (res instanceof Thread && res.getId() !== null) {
        this.thread = res;
        this.messageService.sendMessage(thread, this.message).subscribe(msg => {
          if (msg instanceof BasicError) {
            console.log('Failed to send Message');
            console.log(msg);
            this.buttonClass = 'btn-warning';
            this.buttonValue = 'Nachricht konnte nicht gesendet werden';
            this.onSend = false;
            return;
          }

          if (this.mailUser !== null) {
            this.messageService.addParticipants(thread, [this.mailUser]).subscribe(usr => {
              if (usr instanceof BasicError) {
                console.log('Failed to add participants');
                console.log(usr);
                this.buttonClass = 'btn-warning';
                this.buttonValue = 'Teilnehmer konnten nicht hinzugefügt werden';
                return;
              }

              this.buttonClass = 'sendedButton';
              this.buttonValue = 'Versendet';
              this.successSend = true;
            });
          } else {
            this.buttonClass = 'sendedButton';
            this.buttonValue = 'Versendet';
          }
        });
      } else {
        // Thread was created but failed to get Id
        console.log('Failed to get Id of thread');
        this.buttonClass = 'btn-warning';
        this.buttonValue = 'Thread erstellt, Nachricht fehlgeschlagen';
        this.onSend = false;
      }
    });
  }


  /**
   * Analyzing the amount of alarms
   * @param alarms alarms to analyze
   */
  public amountAlarms(alarms: Array<Alarm>) {
    let count = 0;

    for (const alarm of alarms) {
      if (alarm.isAlarm()) {
        count = count + 1;
      }
    }

    return count;
  }

}



// WEBPACK FOOTER //
// C:/Users/andyw/Documents/Uni/Master/Masterprojekt/Angular/src/app/components/hcpalarms-list/hcpalarms-list.component.ts